import {useCallback} from 'react';

import {useCatalogue} from '../hooks/useCatalogue';

// Features with lower priority on top, features with undefined priority (=0) on bottom, sorted alphabetically
export const useFeatureCompare = () => {
  const {getFeatureLabel, getFeaturePriority} = useCatalogue();

  const featureCompare = useCallback(
    (a: string, b: string) => {
      const aPriority = getFeaturePriority(a);
      const bPriority = getFeaturePriority(b);

      if (aPriority === bPriority) {
        return getFeatureLabel(a).localeCompare(getFeatureLabel(b));
      }
      if (aPriority === 0) {
        return 1;
      }
      if (bPriority === 0) {
        return -1;
      }
      return aPriority - bPriority;
    },
    [getFeatureLabel, getFeaturePriority]
  );

  return featureCompare;
};
